import React from 'react';
import { Button, Glyphicon, Nav, Navbar, NavItem } from 'react-bootstrap';

//todo: use as alternative to main navbar?
//todo: consider adding icons to action buttons
const ActionBar = (props) => {
    const disableBtns = props.epecDisabled || false;
    return (
        <Navbar fluid fixedTop style={{ background: '#343a40', border: 'none', marginBottom: '0.2rem' }}>
            <Nav pullLeft bsClass="nav nav-no-padding">
                <NavItem>
                    <Button onClick={props.toggleImageUploadModal}>
                        <Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images
                    </Button>
                </NavItem>
            </Nav>
            <Nav pullRight bsClass="nav nav-no-padding">
                {
                    <NavItem>
                        <Button onClick={props.toggleWorkflowHistoryModal} disabled={!props.showWorkflowHistory}>
                            Workflow History
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
                {
                    props.showReprint &&
                    <NavItem>
                        <Button onClick={props.toggleReprintModal} disabled={disableBtns}>
                            Reprint
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
                {
                    !props.isViewOnly &&
                    <NavItem>
                        <Button onClick={props.saveWorkflow} disabled={disableBtns}>
                            Save
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
                {
                    !props.isViewOnly &&
                    <NavItem>
                        <Button onClick={props.saveWorkflowForLater} disabled={disableBtns}>
                            Save for Later
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
                {
                    !props.isViewOnly &&
                    <NavItem>
                        <Button onClick={props.completeWorkflow} disabled={disableBtns}>
                            Complete
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
                {
                    props.isViewOnly &&
                    <NavItem>
                        <Button onClick={props.redirectToLanding}>
                            Return to Landing
                            {/*<Glyphicon glyph="picture" style={{ fontWeight: '800', marginRight: '0.6rem' }} /> Images*/}
                        </Button>
                    </NavItem>
                }
            </Nav>
        </Navbar>
    );
}

export default ActionBar;